
class CartRemoveButton extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-products') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
  
      });
    }
  }
  
  customElements.define('remove-item', CartRemoveButton);


  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
        
      }, 300);
 
      this.addEventListener('change', this.debouncedOnChange.bind(this));
      
   
    }
  
    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  
    getSectionsToRender() {
    
      return [
        {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents',
        },
        {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.cart-totle-text',
        }
      ];
    }
  
    updateQuantity(line, quantity, name) {
      this.enableLoading(line);
   
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
         
          return response.text();
 
        })
        .then((state) => {
    
          const parsedState = JSON.parse(state);
         
          //item_count
          cartItemCount(parsedState.item_count)
          drawerFreeDelveryLine(parsedState.total_price)
         
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
  
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
         
          
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        
          }));
  

 

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
         

          this.disableLoading();
    
        })
        
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));

          this.disableLoading();
        });
    }
  
    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        lineItemError
          .querySelector('.cart-item-error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            quantityElement.value
          );
      }

      this.currentItemCount = itemCount;
  
      const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
  
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items');
   
      const cartItemElements = this.querySelectorAll(`.cart-item[data-line="${line}"] .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`.cart-item[data-line="${line}"] .loading-overlay`);
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
     
    }
  
    disableLoading() {
      const mainCartItems = document.getElementById('main-cart-items');
     
    }
  }
  
  customElements.define('cart-products', CartItems);
  
  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();
  
        this.addEventListener('change', debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300))
      }
    });
  };
 
/*********************************************************** */
/********************** advanced js***************************/
/*********************************************************** */
//cart item count
function cartItemCount(item_count) {
  let cartCount = document.querySelectorAll('.cart-counter');
  cartCount.forEach(item => {
    item.innerHTML = item_count;
  })
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
if(typeof currencyIso_code !== 'undefined'){
  if(currencyIso_code == ''){
      currencyIso_code = '$'
  }
}else{
    var currencyIso_code = '$'
}
if(typeof cartAmout !== 'undefined'){
    if(cartAmout == ''){
        cartAmout = '{{amount}}'
    }
}else{
    var cartAmout = '{{amount}}'
}

Shopify.money_format = currencyIso_code+cartAmout;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


//Free delivery price count
function drawerFreeDelveryLine(totalPrice){ 

  if(document.querySelectorAll('.cart-freeshipping-line').length > 0){
    
    document.querySelectorAll('.cart-freeshipping-line').forEach((item)=>{
      if(item.dataset.shipping){
        let currentTotal = Shopify.formatMoney(totalPrice, Shopify.money_format).replace(/\,/g,'').slice(1);
        let freeMoneyDelivery = Number(item.dataset.shipping); 

        let leaveMoney = 0;
        let percentleave = 0;

        if(currentTotal < freeMoneyDelivery){
            leaveMoney = freeMoneyDelivery - Number(currentTotal);
            percentleave = Number(currentTotal) * 100 / freeMoneyDelivery;
            item.querySelector('.cart-freeshipoing-indicator-line').style.left = percentleave-100+'%'
           
            item.classList.remove('free-get');

        }else{
          item.querySelector('.cart-freeshipoing-indicator-line').style.left = '0';
     
            item.classList.add('free-get');
          
        }
        item.querySelector('.cart-freeshipping-price').innerHTML = currencyIso_code+''+leaveMoney.toFixed(2);

      }
    })
  }
}

//first load page show shiping
function fetchCart() {
  fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: {'Accept': `application/javascript`, 'X-Requested-With':`XMLHttpRequest`}
  })
  .then((response) => response.json())
  .then((cart) => {
      //delivery line count
      drawerFreeDelveryLine(cart.total_price)
  })
}fetchCart()